import { useEffect, useState } from "react";

export function useTranslations(locale) {
  const [translations, setTranslations] = useState({});

  useEffect(() => {
    let active = true;

    const load = async (loc) => {
      setTranslations({});
      try {
        const res = await fetch(`/api/translations?locale=${loc}`);
        const data = await res.json();
        const map = {};

        (data.rows || []).forEach((row) => {
          const key = `${row.entity_type}:${row.entity_id}:${row.field_name}`;
          map[key] = row.text_content;
          // Also index UI strings by field_name alone so tUI("key") works
          // regardless of which ui_labels.id the row points to
          if (row.entity_type === "ui") {
            map[`ui:0:${row.field_name}`] = row.text_content;
          }
        });

        if (active) setTranslations(map);
      } catch (err) {
        console.error("failed to load translations", err);
      }
    };

    load(locale);
    const handler = (e) => load(e.detail);
    document.addEventListener("localeChange", handler);
    return () => {
      active = false;
      document.removeEventListener("localeChange", handler);
    };
  }, [locale]);

  return translations;
}
